import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { useContent } from "../content/ContentContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { SITE } = useContent();

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/subscribe`, { email: email.trim() });
      toast.success(
        data.status === "already_subscribed"
          ? "You're already part of the conversation."
          : "Welcome to the family. The next conversation will find you."
      );
      setEmail("");
    } catch {
      toast.error("Something interrupted the conversation. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="join" className="relative py-24 md:py-36 border-y border-white/10 bg-coal/40" data-testid="newsletter-section">
      <div className="absolute left-1/2 top-0 -translate-x-1/2 w-[640px] h-[320px] rounded-full bg-gold/[0.06] blur-[150px] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-20 items-center">
          <Reveal>
            <p className="overline-label mb-5">{SITE.newsletter.overline}</p>
            <h2 className="font-display text-4xl sm:text-5xl leading-tight" data-testid="newsletter-heading">
              {SITE.newsletter.headingMain} <span className="italic text-gold-light">{SITE.newsletter.headingAccent}</span>
            </h2>
            <p className="text-sm md:text-base text-smoke mt-6 max-w-md leading-relaxed" data-testid="newsletter-text">
              {SITE.newsletter.body}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3" data-testid="newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 bg-transparent border border-white/15 focus:border-gold/70 rounded-full px-6 py-4 text-sm text-ivory placeholder:text-smoke/70 outline-none transition-colors duration-300"
                data-testid="newsletter-email-input"
              />
              <button
                type="submit"
                disabled={loading}
                className="inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-light disabled:opacity-60 text-ink text-[11px] font-semibold tracking-[0.24em] uppercase px-8 py-4 rounded-full transition-colors duration-300"
                data-testid="newsletter-submit-button"
              >
                {loading ? <Loader2 size={14} className="animate-spin" /> : <ArrowRight size={14} />}
                Join the conversation
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
